<template>
  <div>
    <div class="table-action-box table-action-delete" @click="dialog = true">
      <v-icon small>mdi-delete-outline</v-icon>
      <span class="table-action-label">Excluir</span>
    </div>

    <ModalConfirmAction
      :visible="dialog"
      title="Excluir produção"
      message="Você tem certeza que deseja remover a producão?"
      :loading="loading"
      @confirm="deleteProducao"
      @cancel="dialog = false"
    />
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    cod_producao: Number,
    dsc_login_producao: String,
    fetchData: Function,
  },
  data() {
    return {
      loading: false,
      dialog: false,
    };
  },
  methods: {
    async deleteProducao() {
      try {
        this.loading = true;
        const response = await apiClient.patch(
          `removerProducao/${this.cod_producao}`,
          {
            dsc_login_producao: this.dsc_login_producao,
          }
        );
        if (response.status === 200) {
          this.$toast.success("Produção excluida com sucesso!");
        } else {
          this.$toast.error("Erro ao excluir produção...");
        }
      } catch (error) {
        this.$toast.error("Erro ao excluir produção...");
      } finally {
        this.dialog = false;
        this.loading = false;
        await this.fetchData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
